export const TWILIO_MESSAGING_SERVICE_FRIENDLY_NAME = "OneText_Primary";
